export * from './easy-tab-component';
